import axios from "axios";
import { API_URL } from "../constant";

const API_BASE_URL = API_URL || "https://staging.api.topcoinuk.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const supplierService = {
  // Get all suppliers with pagination and filters
  getAllSuppliers: async (params = {}) => {
    const response = await api.get("/superadmin/suppliers", { params });
    return response.data;
  },

  // Get specific supplier details
  getSupplier: async (supplierId) => {
    const response = await api.get(`/superadmin/suppliers/${supplierId}`);
    return response.data;
  },

  // Create new supplier
  createSupplier: async (supplierData) => {
    const response = await api.post(
      "/superadmin/suppliers",
      supplierData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  // Update supplier
  updateSupplier: async (supplierId, supplierData) => {
    const response = await api.post(
      `/superadmin/suppliers/${supplierId}`,
      supplierData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },

  // Delete supplier
  deleteSupplier: async (supplierId) => {
    const response = await api.delete(
      `/superadmin/suppliers/${supplierId}`
    );
    return response.data;
  },

  // Update supplier status
  updateSupplierStatus: async (supplierId, statusData) => {
    const response = await api.post(
      `/superadmin/suppliers/${supplierId}/status`,
      statusData
    );
    return response.data;
  },

  // Reset supplier password
  resetSupplierPassword: async (supplierId, passwordData) => {
    const response = await api.post(
      `/superadmin/suppliers/${supplierId}/reset-password`,
      passwordData
    );
    return response.data;
  },

  // Get supplier count
  getSupplierCount: async (filters = {}) => {
    const response = await api.get('/superadmin/suppliers/count', {
      params: filters
    });
    return response.data;
  },

  // Key Management Methods
  getPublicKey: async (supplierId) => {
    const response = await api.get(`/superadmin/suppliers/${supplierId}/public-key`);
    return response.data;
  },

  regenerateKeyPair: async (supplierId, algorithm = 'rsa') => {
    const response = await api.post(`/superadmin/suppliers/${supplierId}/regenerate-keys`, {
      algorithm
    });
    return response.data;
  },

  getKeyStatus: async (supplierId) => {
    const response = await api.get(`/superadmin/suppliers/${supplierId}/key-status`);
    return response.data;
  },

  // Check email availability
  checkEmailAvailability: async (email) => {
    try {
      const response = await api.post(
        "/superadmin/suppliers/check-email-availability",
        { email }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check phone availability
  checkPhoneAvailability: async (phone) => {
    try {
      const response = await api.post(
        "/superadmin/suppliers/check-phone-availability",
        { phone }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get supplier products
  getSupplierProducts: async (supplierId, params = {}) => {
    try {
      const response = await api.get(
        `/superadmin/suppliers/${supplierId}/products`,
        { params }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};